<button
  mat-fab
  color="warn"
  [disabled]="openSpace ? !openSpace.allowedProposalCreation : false"
  (click)="addProposal()"
  title="Crear propuesta"
  style="outline: none"
>
  <mat-icon>add</mat-icon>
</button>
<div class="row-fluid">
  <div class="sticky_note">
    <ul style="margin-top: 50px">
      <li
        *ngFor="let proposal of proposals; index as i"
        class="sticky_{{ this.getColor(i) }} postit"
      >
        <app-note
          [proposal]="proposal"
          [categories]="categories"
          [colorOption]="this.getColor(i)"
          (proposalNewDataEmiter)="reLoadProposals()"
        >
        </app-note>
      </li>
    </ul>
  </div>
</div>
